var map = {
	"./layout.two-columns-2-1.html": 615,
	"./layout.two-equal-cols.html": 616,
	"./page.basic.html": 617,
	"./page.frontpage-parallax-full.html": 618
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 614;



//////////////////
// WEBPACK FOOTER
// ./client/components/html-page-snippets ^\.\/.*\.html$
// module id = 614
// module chunks = 0